import Insights from '@/components/Insights';

const Survey = () => <Insights />;

export default Survey;
